import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { de_StartDocumentAnalysisCommand, se_StartDocumentAnalysisCommand } from "../protocols/Aws_json1_1";
export { $Command };
export class StartDocumentAnalysisCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("Textract", "StartDocumentAnalysis", {})
    .n("TextractClient", "StartDocumentAnalysisCommand")
    .f(void 0, void 0)
    .ser(se_StartDocumentAnalysisCommand)
    .de(de_StartDocumentAnalysisCommand)
    .build() {
}
